import React, { CSSProperties } from "react";
import { omit } from "../../libs/utils/object";

type FlexProps = React.HTMLAttributes<HTMLDivElement> & {
    flex?: CSSProperties["flex"];
};

export const Flex: React.FC<FlexProps> = (props: FlexProps) => {
    const style: CSSProperties = {
        flex: props.flex,
    };
    return (
        <div data-testid="Flex" style={style} {...omit(props, ["flex"])}>
            {props.children}
        </div>
    );
};

type SpacerProps = Omit<FlexProps, "flex">;

export const Spacer: React.FC<SpacerProps> = (props: SpacerProps) => (
    <Flex data-testid="Spacer" {...props} flex={1} />
);

type ExpandedProps = { children?: React.ReactNode };

export const Expanded: React.FC<ExpandedProps> = (props: ExpandedProps) => (
    <Flex data-testid="Expanded" {...props} flex={1}>
        {props.children}
    </Flex>
);
